var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9468 8.17901C19.884 7.99388 19.7683 7.83121 19.614 7.71107C19.4598 7.59094 19.2737 7.51861 19.0788 7.50301L13.3778 7.05001L10.9108 1.58901C10.8323 1.41313 10.7045 1.26374 10.5429 1.15887C10.3813 1.05401 10.1928 0.998153 10.0002 0.998047C9.80753 0.997941 9.61898 1.05359 9.45727 1.15828C9.29556 1.26296 9.1676 1.41221 9.08884 1.58801L6.62184 7.05001L0.920843 7.50301C0.729298 7.51819 0.546181 7.58822 0.393398 7.70475C0.240615 7.82127 0.124636 7.97934 0.0593363 8.16004C-0.00596349 8.34075 -0.017819 8.53645 0.0251881 8.72372C0.0681952 8.91099 0.164244 9.0819 0.301843 9.21601L4.51484 13.323L3.02484 19.775C2.9796 19.9703 2.9941 20.1747 3.06646 20.3617C3.13882 20.5486 3.26571 20.7095 3.43064 20.8235C3.59558 20.9374 3.79096 20.9991 3.99143 21.0007C4.19189 21.0022 4.38819 20.9434 4.55484 20.832L9.99984 17.202L15.4448 20.832C15.6152 20.9451 15.8161 21.0033 16.0205 20.9988C16.2249 20.9944 16.423 20.9274 16.5882 20.8069C16.7535 20.6865 16.8778 20.5183 16.9446 20.3251C17.0114 20.1318 17.0174 19.9228 16.9618 19.726L15.1328 13.326L19.6688 9.24401C19.9658 8.97601 20.0748 8.55801 19.9468 8.17901Z",
    fill: "#F5B434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.1a00794c8c0cd8694c3d50de0a4fd053.svg";
export { ForwardRef as ReactComponent };